module.exports = __webpack_public_path__ + "static/media/largeRedShield.bae6a997.svg";